import { ApiSuccess, FilePurpose, ProspectCategory, ProspectType } from '../../types';
import { apiSlice } from '../api.services';

type ProcessUrlType = {
  url: string;
} & (
  | {
      // Category and type are required for prospect creation
      purpose: FilePurpose.PROSPECT_CREATION;
      prospectCategory: ProspectCategory;
      prospectType: ProspectType;
    }
  | {
      purpose: FilePurpose.CALL_CREATION;
      prospectCategory?: never;
      prospectType?: never;
    }
);

type ProcessUrlPayload = {
  urls: ProcessUrlType[];
};

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    submitUrl: builder.mutation<ApiSuccess, string>({
      query: (link) => ({
        url: '/url',
        method: 'POST',
        body: { url: link },
      }),
    }),
    processUrl: builder.mutation<ApiSuccess, ProcessUrlPayload>({
      query: (payload) => ({
        url: '/transcription-pipelines/process-url',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useSubmitUrlMutation, useProcessUrlMutation } = enhancedApiSlice;
